import AlertStore from './AlertStore';
import BootstrapVariant from '../../vendor/bootstrap/BootstrapVariant';
import AlertContext from './AlertContext';

const DEFAULT_CONFIG = {
  CONTEXT: AlertContext.GLOBAL,
  TTL: 3,
};

const DEFAULT_MODAL_CONFIG = {
  CONTEXT: AlertContext.MODAL,
  TTL: 3,
};

function showSuccess(text, config = {}) {
  const mergedConfig = { ...DEFAULT_CONFIG, ...config };
  AlertStore.add(
    text,
    BootstrapVariant.SUCCESS,
    mergedConfig.CONTEXT,
    mergedConfig.TTL,
  );
}

function showWarning(text, config = {}) {
  const mergedConfig = { ...DEFAULT_CONFIG, ...config };
  AlertStore.add(
    text,
    BootstrapVariant.WARNING,
    mergedConfig.CONTEXT,
    mergedConfig.TTL,
  );
}

function showError(text, config = {}) {
  const mergedConfig = { ...DEFAULT_CONFIG, ...config };
  AlertStore.add(
    text,
    BootstrapVariant.DANGER,
    mergedConfig.CONTEXT,
    mergedConfig.TTL,
  );
}

function showInfo(text, config = {}) {
  const mergedConfig = { ...DEFAULT_CONFIG, ...config };
  AlertStore.add(text, BootstrapVariant.INFO, mergedConfig.CONTEXT, mergedConfig.TTL);
}

const AlertService = {
  DEFAULT_CONFIG,
  DEFAULT_MODAL_CONFIG,
  showSuccess,
  showWarning,
  showError,
  showInfo,
};

export default AlertService;
